import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from './CustomFalseCeiling.module.scss';
import { FalseCeilingOverviewTabs } from './CustomFalseCeilingConstants';
import TavViewSection from "./CustomTabViewSection";
import { saveUpdatedPageDetails, saveMetaDataUpdate } from "../../../actions/wizard";
import CustomTextareaView from "./CustomTextareaView";

const CustomFalseCeilingOverview = (props: any) => {
  const dispatch = useDispatch();
  const { isDrawingsExporting } = props;
  const pageDetails = useSelector((state: any) => state.wizard.pageDetails);
  const requiredMetaDataUpdate = useSelector((state: any) => state.wizard.requiredMetaDataUpdate);

  const latestStateRef = useRef(requiredMetaDataUpdate);

  const [updatedValues, setUpdatedValues] = useState(pageDetails);

  // Update the meta details while unmounting.
  useEffect(() => {
    return () => {
      updateDetailsInMeta(false);
    }
  }, [])

  // Updating Item details in meta data
  const updateItems = (details: any) => {
    const updatedObj: any = {
      ...updatedValues,
      metaData: {
        ...updatedValues?.metaData,
        [details.id]: details.value
      }
    };
    setUpdatedValues(updatedObj)
    dispatch(saveMetaDataUpdate(updatedObj))
  }

  // Save function to save details in API
  const updateDetailsInMeta = (required: boolean) => {  
    if (latestStateRef.current) {
      dispatch(saveUpdatedPageDetails(latestStateRef.current, required));
      dispatch(saveMetaDataUpdate(false))
    }
  }

  // Created a debounce to update the exiting quote details 
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      updateDetailsInMeta(true);
    }, 4000); // Adjust the delay (in milliseconds) as needed

    latestStateRef.current = requiredMetaDataUpdate;

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [requiredMetaDataUpdate]);

  // Created a debounce to update the exiting quote details 
  useEffect(() => {
    setUpdatedValues(pageDetails);
    if(!pageDetails?.metaData?.design_type && pageDetails?.fc_type?.includes('Standard')) {
      updateItems({ id: 'design_type', value: 'Standard' })
    }
  }, [pageDetails]);

  return (
    <section className={style.ceiling_overview_section}>
      <div className={style.details_vew}>
        <h4 className="section_heading">1. Overview</h4>
        <div className={style.false_ceiling_overview}>
          <div className={style.rightSection_tab}>
            {pageDetails?.pageType !== 'created_page' ? <h4 className="sub_tab_heading">Specifications for Finish (*Mandatory)</h4> : ''}
            {
              pageDetails?.pageType !== 'created_page' ? pageDetails?.paintDetails?.length ? pageDetails?.paintDetails?.map((e, i) => (
                <>
                  <div className={style.sub_value_tab} key={i}>
                    <p className={style.sub_label}>Paint Shade {i + 1}:</p>
                    <div className={style.sub_value}>
                      <p>{e.color}</p>
                    </div>
                  </div>
                  <div className={style.sub_value_tab} key={i}>
                    <p className={style.sub_label}>Paint Process {i + 1}:</p>
                    <div className={style.sub_value}>
                      <p>{e.product_name}</p>
                    </div>
                  </div>
                  <div className={style.sub_value_tab} key={i}>
                    <p className={style.sub_label}>Paint Quantity {i + 1}:</p>
                    <div className={style.sub_value}>
                      <p>{e.area}</p>
                    </div>
                  </div>
                </>
              )) : ''
                :
                FalseCeilingOverviewTabs?.paintDetails?.map((e: any, i: any) => <CustomTextareaView details={e} index={i} isDrawingsExporting={isDrawingsExporting} updateDetails={(e) => updateItems(e)} itemDetails={updatedValues?.metaData} />)
            }
          </div>
        </div>
      </div>
      <div className={style.canvas_view_tab}>
        <div className={style.image_view_section}>
          <div>
            <p>3D VIEW {pageDetails?.images?.length ? `- ${pageDetails?.images?.[0]?.name}` : ''}</p>
            {
              pageDetails?.images?.length ? <img crossOrigin="anonymous" alt={pageDetails?.images?.[0]?.name} src={pageDetails?.images?.[0]?.imageUrl} className="image-view" /> : ''
            }
          </div>
          <div>
            <p>3D VIEW {pageDetails?.images?.length ? `- ${pageDetails?.images?.[1]?.name}` : ''}</p>
            {
              pageDetails?.images?.length ? <img crossOrigin="anonymous" alt={pageDetails?.images?.[1]?.name} src={pageDetails?.images?.[1]?.imageUrl} className="image-view" /> : ''
            }
          </div>
        </div>
        <div className={style.over_view_sow}>
          {
            FalseCeilingOverviewTabs?.leftBar?.map((e: any, i: any) => <TavViewSection details={e} index={i} isDrawingsExporting={isDrawingsExporting} updateDetails={(e) => updateItems(e)} itemDetails={updatedValues?.metaData} />)
          }
        </div>
      </div>
    </section>
  )
}

export default CustomFalseCeilingOverview;